<template>
  <div class="more">
    <div style="position:fixed;width:100%;">
      <wv-search-bar
        :autofocus="false"
        v-model="value"
        @search="onSearch"
        @cancel="onCancel"
        placeholder="请输入搜索的内容"
      />
      <mt-navbar v-model="selected" style="border-bottom:1px solid lightgray;">
        <mt-tab-item @click.native="serviceType()" id="1" style="border-right:1px solid lightgray;">服务类型ˇ</mt-tab-item>
        <mt-tab-item @click.native="serviceItem()" id="2" style="border-right:1px solid lightgray;">服务项目ˇ</mt-tab-item>
        <mt-tab-item @click.native="defaultSort()" id="3">默认排序ˇ</mt-tab-item>
      </mt-navbar>

    </div>

   <!-- 服务类型-->
    <div>
      <van-popup v-model="showType" position="bottom">
        <van-picker
          show-toolbar
          :columns="columnType"
          @cancel="cancelType"
          @confirm="confirmType"
        />
      </van-popup>
    </div>
    <!--服务项目-->
    <div>

      <van-popup v-model="showItem" position="bottom">
        <van-picker
          show-toolbar
          :columns="columnItem"
          @cancel="cancelItem"
          @confirm="confirmItem"
        />
      </van-popup>
    </div>

    <div>
      <!-- 默认排序-->
      <van-popup v-model="showDefault" position="bottom">
        <van-picker
          show-toolbar
          :columns="columnDefault"
          @cancel="cancelDefault"
          @confirm="confirmDefault"
        />
      </van-popup>
    </div>
    <div>
      <div style="width:100%;height:77px;"></div>
      <moveView ref="moveView"></moveView>
    </div>
  </div>
</template>

<script>
  import { getByLikeContent,getServiceItem,getServiceItemByPid,OK,HOST} from '../api/data.js'
  import moveView from './moveView'
  import 'vant/lib/index.css';
  import { Picker } from 'vant';
  import { Popup } from 'vant';
  import Vue from 'vue'
  Vue.use(Popup);
  Vue.use(Picker);

  export default {
    data() {
      return {
        inputShowed: false,
        inputVal: "",
        selected:"1",
        value: '',
        pid:"0",
        showType: false,
        showItem: false,
        showDefault:false,
        title:'后勤服务监督平台',//分享标题
        imgLogo: require('../assets/logo.png'),// 分享图标
        desc: '可点击', //分享描述
        columnType: ['全部', '投诉', '建议', '咨询', '表扬'],
        columnItem:[],
        columnDefault:  ['发帖时间', '阅读数量', '点赞数']
      }
    },
    //页面加载调用
    mounted() {
      this.getItemName();
    },
    computed:{
    },

    methods: {

      //获取服务项目名称
      getItemName(){
        getServiceItemByPid(this.pid).then((res) => {
          if(res.status === OK) {
            let i = 0;
           for (i = 0;i<res.data.data.length;i++) {
             this.columnItem[i] =res.data.data[i].name;
            }

          }else{
            Toast('获取服务项失败')
          }
        })
          .catch((error) => {
            console.log(error)
          });
      },
      serviceType () {
        this.toShowType();
        this.closeDefault()
        this.closeItem()
      },
      serviceItem () {
        this.toShowItem();
        this.closeDefault()
        this.closeType()
      },
      defaultSort () {
        this.toShowDefault();
        this.closeType()
        this.closeItem()
      },
      onSearch (value) {
        // 根据内容关键字搜索
        this.$refs.moveView.getLikeContent(value); //调用子组件的方法


      },
      onCancel () {
        // 自定义取消事件处理
      },
      confirmType(value, index) {
        //this.value = value;
        this.showType = false;
        this.$refs.moveView.getServiceType(index);

      },
      cancelType(value, index){
        this.showType = false;
      },
      closeType() {
        this.showType = false
      },
      toShowType() {
        this.showType = true
      },

      confirmItem(value, index) {
        //this.value = value;
        this.showItem = false;
      /*  console.log(`当前值：${value}, 当前索引：${index}`);*/
        this.$refs.moveView.getServiceItem(value);

      },
      cancelItem(value, index){
        this.showItem = false;
      },
      closeItem() {
        this.showItem = false
      },
      toShowItem() {
        this.showItem = true
      },

      confirmDefault(value, index) {
        //this.value = value;
        this.showDefault = false;
        this.$refs.moveView.getDefaultSort(index);
        //console.log(`当前值：${value}, 当前索引：${index}`);
      },
      cancelDefault(value, index){
        this.showDefault = false;
      },
      closeDefault() {
        this.showDefault = false
      },
      toShowDefault() {
        this.showDefault = true
      },
    },
    components:{
      moveView

    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/baseScss.scss";
  .more{
  .mint-navbar{
  a{
  .mint-tab-item-label{
  }

  }

  .mint-tab-item{
    padding:10px 0;
  }
  .mint-tab-item-label{
    font-size: 14px;
    border-right: solid 1px $cl9;
  }
  }
  .mint-tab-item.is-selected{
    border:none;
  }
  .is-selected{
    margin-bottom: 0px !important;
  }
  }

</style>



// WEBPACK FOOTER //
// src/components/more.vue